import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Cart from "../Cart";
import "./paymentType.css";
import PhonePay from "../../assets/phonepe-payment.svg";
import GooglePay from "../../assets/gpay.svg";
import Paytm from "../../assets/paytm-payment.svg";
import { setPaymentMode } from "../../store/order.store";
import { usePlaceOrderMutation } from "../../hooks";

export default function PaymentType() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { config, cart } = useSelector((each) => ({
    config: each.config,
    cart: each.cart
  }));

  const shippingAmount = useMemo(() => {
    if (
      cart.cartDetails?.totalAmount >
      (config?.shipping_charge_max_threshold ?? 499)
    )
      return 0;
    return config?.shipping_charge_amount ?? 50;
  }, [config, cart]);

  const isCodEnable = useMemo(
    () =>
      config?.cod &&
      cart.cartDetails.finalAmount + shippingAmount <= config.max_cod_amount,
    [config, cart, shippingAmount]
  );

  const { mutateAsync: placeOrderMutationAsync, status: placeStatus } =
    usePlaceOrderMutation();

  const continueToPayment = useCallback(
    async (paymentMode) => {
      if (!["cod", "credit"].includes(paymentMode))
        throw new Error("Invalid input argument!");

      const shippingAddressId = state?.shippingAddressId;
      const billingAddressId = state?.billingAddressId;
      if (paymentMode === "cod") {
        dispatch(setPaymentMode("cod"));
      } else if (paymentMode === "credit") {
        dispatch(setPaymentMode("credit"));
      }
      if (paymentMode === "credit")
        await placeOrderMutationAsync({ paymentMode });
      return navigate("/payment", {
        state: { shippingAddressId, billingAddressId }
      });
    },
    [dispatch, state, navigate]
  );

  const styling = config?.cod ? "bottom-box-with-cod" : "bottom-box";
  return (
    <div
      className={`payment-container ${isCodEnable ? "payment-container-padding" : ""}`}
    >
      <div className="mobile-cart">
        <Cart />
      </div>
      <div className={styling}>
        <button
          type="button"
          className="pay-online"
          id="pay-online-btn"
          disabled={placeStatus === "pending"}
          onClick={() => continueToPayment("credit")}
        >
          <h3>Pay Online</h3>
          <div className="payment-mode">
            <img src={Paytm} alt="Paytm" className="paytm" />
            <img src={PhonePay} alt="PhonePay" className="phonePay" />
            <img src={GooglePay} alt="GooglePay" />
          </div>
        </button>
        {isCodEnable && (
          <button
            type="button"
            className="pay-online"
            onClick={() => continueToPayment("cod")}
            disabled={placeStatus === "pending"}
          >
            <h3>Order via COD</h3>
          </button>
        )}
      </div>
    </div>
  );
}
